"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.number = void 0;
const decimal_js_1 = require("decimal.js");
const exception_1 = require("../exception");
const number_1 = require("../number");
const unit_1 = require("../unit");
const value_1 = require("../value");
const unaryMethod = (callback) => (context) => {
    const { value, unit } = context.popNumber();
    context.pushNumber(callback.call(decimal_js_1.Decimal, value), unit);
};
const binaryMethod = (callback) => (context) => {
    var _a;
    const b = context.popNumber();
    const a = context.popNumber();
    const base = (0, unit_1.getBaseUnitOf)((_a = a.unit) === null || _a === void 0 ? void 0 : _a.type);
    (0, number_1.unitCheck)(a, b);
    context.push((0, number_1.unitConversion)(callback.call(decimal_js_1.Decimal, (0, number_1.toBaseUnit)(a), (0, number_1.toBaseUnit)(b)), base));
};
const w_hasUnit = (context) => {
    context.pushBoolean(context.peekNumber().unit != null);
};
const w_unit = (context) => {
    const { unit } = context.peekNumber();
    if (unit == null) {
        throw new exception_1.UnitError("Value has no measurement unit.");
    }
    context.pushString(unit.symbol);
};
const w_unitType = (context) => {
    const { unit } = context.peekNumber();
    if (unit == null) {
        throw new exception_1.UnitError("Value has no measurement unit.");
    }
    context.pushString(unit.type.toLowerCase());
};
const w_dropUnit = (context) => {
    context.pushNumber(context.popNumber().value);
};
const w_range = (context) => {
    var _a;
    const end = context.popNumber();
    const begin = context.popNumber();
    const result = [];
    (0, number_1.unitCheck)(end, begin);
    const baseEnd = (0, number_1.toBaseUnit)(end);
    const baseUnit = (0, unit_1.getBaseUnitOf)((_a = end.unit) === null || _a === void 0 ? void 0 : _a.type);
    let current = (0, number_1.toBaseUnit)(begin);
    while (current.comparedTo(baseEnd) < 0) {
        result.push((0, value_1.newNumberValue)(current, baseUnit));
        current = current.add(1);
    }
    context.pushVector(result);
};
const w_clamp = (context) => {
    var _a;
    const value = context.popNumber();
    const max = context.popNumber();
    const min = context.popNumber();
    (0, number_1.unitCheck)(value, max, min);
    context.push((0, number_1.unitConversion)((0, number_1.toBaseUnit)(value).clamp((0, number_1.toBaseUnit)(min), (0, number_1.toBaseUnit)(max)), (0, unit_1.getBaseUnitOf)((_a = value.unit) === null || _a === void 0 ? void 0 : _a.type)));
};
const w_times = (context, print) => {
    let { value } = context.popNumber();
    const quote = context.popQuote();
    while (value.comparedTo(0) > 0) {
        value = value.sub(1);
        quote.call(context, print);
    }
};
const w_deg = (context) => {
    const { value, unit } = context.popNumber();
    context.pushNumber(value.mul(180).div(Math.PI), unit);
};
const w_rad = (context) => {
    const { value, unit } = context.popNumber();
    context.pushNumber(value.mul(Math.PI).div(180), unit);
};
const w_toMonth = (context) => {
    const { value } = context.popNumber();
    if (value.comparedTo(1) < 0 || value.comparedTo(12) > 0) {
        throw new exception_1.RangeError("Month index out of range.");
    }
    context.pushMonth(value.toNumber() - 1);
};
const w_toWeekday = (context) => {
    const { value } = context.popNumber();
    if (value.comparedTo(1) < 0 || value.comparedTo(7) > 0) {
        throw new exception_1.RangeError("Weekday index out of range.");
    }
    context.pushWeekday(value.toNumber() - 1);
};
exports.number = [
    ["number:has-unit?", w_hasUnit],
    ["number:unit", w_unit],
    ["number:unit-type", w_unitType],
    ["number:drop-unit", w_dropUnit],
    ["number:range", w_range],
    ["number:clamp", w_clamp],
    ["number:times", w_times],
    // Exponential functions.
    ["number:exp", unaryMethod(decimal_js_1.Decimal.exp)],
    // TODO: ["number:exp2", w_exp2],
    // TODO: ["number:expm1", w_expm1],
    ["number:log", unaryMethod(decimal_js_1.Decimal.log)],
    ["number:log10", unaryMethod(decimal_js_1.Decimal.log10)],
    ["number:log2", unaryMethod(decimal_js_1.Decimal.log2)],
    // TODO: ["number:log1p", w_log1p]
    // Power functions.
    ["number:pow", binaryMethod(decimal_js_1.Decimal.pow)],
    ["number:sqrt", unaryMethod(decimal_js_1.Decimal.sqrt)],
    ["number:cbrt", unaryMethod(decimal_js_1.Decimal.cbrt)],
    ["number:hypot", binaryMethod(decimal_js_1.Decimal.hypot)],
    // Trigonometric functions.
    ["number:acos", unaryMethod(decimal_js_1.Decimal.acos)],
    ["number:asin", unaryMethod(decimal_js_1.Decimal.asin)],
    ["number:atan", unaryMethod(decimal_js_1.Decimal.atan)],
    ["number:atan2", binaryMethod(decimal_js_1.Decimal.atan2)],
    ["number:cos", unaryMethod(decimal_js_1.Decimal.cos)],
    ["number:sin", unaryMethod(decimal_js_1.Decimal.sin)],
    ["number:tan", unaryMethod(decimal_js_1.Decimal.tan)],
    ["number:deg", w_deg],
    ["number:rad", w_rad],
    // Hyperbolic functions.
    ["number:sinh", unaryMethod(decimal_js_1.Decimal.sinh)],
    ["number:cosh", unaryMethod(decimal_js_1.Decimal.cosh)],
    ["number:tanh", unaryMethod(decimal_js_1.Decimal.tanh)],
    ["number:asinh", unaryMethod(decimal_js_1.Decimal.asinh)],
    ["number:acosh", unaryMethod(decimal_js_1.Decimal.acosh)],
    ["number:atanh", unaryMethod(decimal_js_1.Decimal.atanh)],
    // Conversions.
    ["number:>month", w_toMonth],
    ["number:>weekday", w_toWeekday],
];
